import { render, staticRenderFns } from "./stuLogin.vue?vue&type=template&id=11ddb684&scoped=true"
import script from "./stuLogin.vue?vue&type=script&lang=js"
export * from "./stuLogin.vue?vue&type=script&lang=js"
import style0 from "./stuLogin.vue?vue&type=style&index=0&id=11ddb684&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ddb684",
  null
  
)

export default component.exports